import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { IoClose } from 'react-icons/io5';
import './NotificationBar.css';

// Mobile-only "find a dealer" bar, fixed to the bottom of the screen (hidden on desktop via CSS).
// Links to the /find-dealer page. Once closed, it stays hidden for the rest of the browser session.
const STORAGE_KEY = 'callistus-notification-closed';

const isClosedInSession = () => {
    try {
        return sessionStorage.getItem(STORAGE_KEY) === '1';
    } catch {
        return false;
    }
};

const NotificationBar = () => {
    const [isVisible, setIsVisible] = useState(!isClosedInSession());

    const handleClose = () => {
        setIsVisible(false);
        try {
            sessionStorage.setItem(STORAGE_KEY, '1');
        } catch {
            // storage unavailable (private mode etc.) — bar just reappears on next page
        }
    };

    if (!isVisible) return null;

    return (
        <div className="notification-bar">
            <Link to="/find-dealer">
                <p>Click here to find Nearby Showroom in your city.</p>
            </Link>
            <IoClose className="close-icon" onClick={handleClose} aria-label="Close" />
        </div>
    );
};

export default NotificationBar;
